// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b18036fd","71":"17659c1c","143":"896e68a5","681":"c8c1a5db","810":"ea32fb9e","812":"426f6f21","841":"818893c1","965":"20faa95e"}[chunkId] + ".chunk.js";
};